function handleMutation(mutationsList, observer) {
    console.log('observing');
    const klaviyoPopup = document.querySelector('.klaviyo-form');
    if (klaviyoPopup) {
        const inputFields = klaviyoPopup.querySelectorAll('input[aria-label]:not([name])'); 
        
        inputFields.forEach(input => {
            const ariaLabel = input.getAttribute('aria-label').replace(/ /g, '_');
            input.setAttribute('name', ariaLabel);
        });

        observer.disconnect();
    }
}

const observer = new MutationObserver(handleMutation);
const observerOptions = { childList: true, subtree: true };
observer.observe(document.body, observerOptions);
